export const bcEnums = {
  services: {
    ALL: 0,
    CHATS: 1,
    EMAILS: 3,
    SMS: 9,
    FACEBOOK: 13,
    ASYNC_MESSAGE: 15,
    OMNI: 16
  },
  serviceNames: {
    0: 'all',
    1: 'chats',
    3: 'emails',
    9: 'sms',
    13: 'facebook',
    15: 'asyncMessage',
    16: 'omniQueue'
  },
  servicePlanTypes: {
    FREE: 0,
    HIDDEN: 4,
    ENTERPRISE: 5
  },
  statuses: {
    OFFLINE: 0,
    AWAY: 1,
    AVAILABLE: 2
  },
  workItem: {
    typeKey: {
      CHAT: 'Chat',
      EMAIL: 'Email',
      COMPOSE_EMAIL: 'ComposeEmail',
      SMS: 'SMS',
      FACEBOOK: 'Facebook',
      ASYNC_MESSAGE: 'AsyncMessage'
    }
  },
  visitorClientTypes: {
    DESKTOP: 0,
    MOBILE: 2
  },
  emailActionTypes: {
    EMAIL_TYPE_DRAFT: 0,
    EMAIL_TYPE_INBOUND: 1,
    EMAIL_TYPE_OUTBOUND: 2,
    EMAIL_TYPE_SPAM: 3,
    EMAIL_TYPE_BOUNCE: 4
  },
  cannedMessageTypes: {
    CHAT: 'CHAT',
    EMAIL: 'EMAIL',
    TEXTCHAT: 'TEXTCHAT'
  },
  interactiveCannedMessageTypes: {
    LIST_PICKER: 'list-picker'
  },
  cannedMessageVariable: {
    START: '${',
    END: '}'
  },
  wrapUpFields: {
    SINGLETEXT: 0,
    DROPDOWN: 1,
    RADIOBOX: 2,
    TEXTAREA: 3
  },
  wrapUpCategories: {
    BUILTIN: 0,
    CUSTOM: 1
  },
  wrapUpBuiltInNames: [
    'USER_CATEGORY',
    'USER_STATUS',
    'CUSTOM_FIELD_1',
    'CUSTOM_FIELD_2'
  ],
  messageTypes: {
    VISITOR: 'VISITOR',
    OPERATOR: 'OPERATOR',
    SYSTEM: 'SYSTEM'
  },
  messageGroupTypes: {
    HELPER: 'HELPER',
    OPERATOR: 'OPERATOR',
    SYSTEM: 'SYSTEM'
  },
  panelAction: {
    OPEN: 'open',
    CLOSE: 'close'
  },
  departments: {
    NO_DEPARTMENT_ID: '0'
  },
  analyticsEvents: {
    SEARCH_OPENED: 'Search Opened',
    SEARCH_CLOSED: 'Search Closed'
  },
  autoAnswerStatuses: {
    OPENED: 2,
    POSITIVE: 3,
    NEGATIVE: 4
  },
  loginErrorCodes: {
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    INVALID_TOKEN: 'INVALID_TOKEN',
    LOGIN_REFUSED: 'LOGIN_REFUSED',
    PRODUCT_MISMATCH: 'PRODUCT_MISMATCH',
    IDENTITY_VALIDATION_FAILED: 'IDENTITY_VALIDATION_FAILED'
  },
  assignNextCodes: {
    ALREADY_ASSIGNED: 'ALREADY_ASSIGNED'
  },
  salesforceCreate: {
    OPEN: 'open',
    CLOSE: 'close'
  },
  accessibilitySettingNames: {
    CONVERSATION_FONT_SIZE: 'conversationFontSize'
  }
};

export enum AssigneeTypes {
  OPERATOR = 'OPERATOR',
  DEPARTMENT = 'DEPARTMENT',
  ACD = 'ACD'
}

export enum OperatorInitialGreetingType {
  NONE = 0,
  LANGUAGE = 1,
  WEBSITE = 2
}

export enum TransferType {
  ESCALATED = 'bcChatBox.escalated',
  TRANSFERRED = 'bcChatBox.transferred',
  AUTO_TRANSFERRED = 'bcChatBox.autoTransferred'
}
